export const buttonStyles = {
  primary: {
    forest: {
      bg: 'forest',
      bgHover: 'forestHover',
      bgDisabled: 'forestDisabled',
      color: 'white',
    },
    sky: {
      bg: 'sky',
      bgHover: 'skyHover',
      bgDisabled: 'skyDisabled',
      color: 'black',
    },
    citron: {
      bg: 'citron',
      bgHover: 'citronHover',
      bgDisabled: 'citronDisabled',
      color: 'black',
    },
    paleSilver: {
      bg: 'paleSilver',
      bgHover: 'skyHover',
      color: 'black',
      borderColor: 'paleSilver',
      borderColorHover: 'skyHover',
    },
  },
  secondary: {
    forest: {
      bg: 'transparent',
      bgDisabled: 'transparent',
      bgHover: 'muted', //#D5D9D7
      color: 'black',
      colorDisabled: 'forestDisabled',
      borderColor: 'forest',
      borderColorHover: 'forestHover',
      borderColorDisabled: 'forestDisabled',
    },
    sky: {
      bg: 'transparent',
      bgHover: 'muted', //#D5D9D7
      color: 'white',
      colorDisabled: 'muted',
      borderColor: 'sky',
      borderColorHover: 'skyHover',
      borderColorDisabled: 'skyDisabled',
    },
    skyLight: {
      bg: 'transparent',
      bgHover: 'skyHover', //#D5D9D7
      color: 'black',
      colorDisabled: 'muted',
      borderColor: 'sky',
      borderColorHover: 'skyHover',
      borderColorDisabled: 'skyDisabled',
    },
    citron: {
      bg: 'transparent',
      bgHover: 'muted', //#D5D9D7
      color: 'white',
      colorDisabled: 'muted',
      borderColor: 'citron',
      borderColorHover: 'citronHover',
      borderColorDisabled: 'citronDisabled',
    },
  },
}

export const flatButtonStyles = {
  forest: {
    color: 'forest',
    colorHover: 'forestHover',
    borderColorHover: 'forestHover',
    colorDisabled: 'forestDisabled',
  },
  citron: {
    color: 'citron',
    colorHover: 'citronHover',
    borderColorHover: 'citronHover',
  },
  skyLight: {
    color: 'darkGray',
    colorHover: 'black',
    borderColorHover: 'skyHover',
  },
  skyDark: {
    color: 'white',
    borderColorHover: 'skyHover',
  },
}
